"use strict";
import { SlideOutMenu } from "components/AccountDrawer/SlideOutMenu";
import { TestnetsToggle } from "components/AccountDrawer/TestnetsToggle";
import Column from "components/deprecated/Column";
import Row from "components/deprecated/Row";
import styled from "lib/styled-components";
import { ChevronRight } from "react-feather";
import { Trans, useTranslation } from "react-i18next";
import { ThemedText } from "theme/components";
import ThemeToggle from "theme/components/ThemeToggle";
import { Flex, Text } from "ui/src";
const Container = styled(Column)`
  height: 100%;
`;
const StyledChevron = styled(ChevronRight)`
  color: ${({ theme }) => theme.neutral2};
`;
const LanguageLabel = styled(Row)`
  white-space: nowrap;
`;
const SettingsButton = ({
  title,
  currentState,
  onClick,
  testId,
  showArrow = true
}) => <Flex row justifyContent="space-between" py="$padding12" onPress={onClick} testID={testId}>
    <Text variant="body3" color="$neutral1">
      {title}
    </Text>
    <LanguageLabel gap="xs" align="center" width="min-content">
      {currentState && <ThemedText.LabelSmall color="neutral2">{currentState}</ThemedText.LabelSmall>}
      {showArrow && <StyledChevron size={20} />}
    </LanguageLabel>
  </Flex>;
export default function SettingsMenu({
  onClose,
  openPortfolioBalanceSettings
}) {
  const { t } = useTranslation();
  return <SlideOutMenu title={<Trans i18nKey="common.settings" />} onClose={onClose}>
      <Container>
        <Flex gap="$gap12">
          <ThemeToggle />
          <SettingsButton
    title={t("settings.setting.smallBalances.title")}
    onClick={openPortfolioBalanceSettings}
    testId="portfolio-balance-settings-button"
  />
        </Flex>
        <TestnetsToggle />
      </Container>
    </SlideOutMenu>;
}
